export default __webpack_public_path__ + "media/images/features/hida/grid-5-4a3483fc063ee729df1d5bb106b21ac3.png";